<template>
  <form class="dashboard-block">
    <h2>Date and Time Preferences</h2>
    <div class="panel panel-grey">
      <div class="panel-body">
        <h3>Timezone</h3>
        <selectize
          class="selectize selectize-single"
          name="timezone"
          v-model="stateTimezone"
          :options="timezoneOptions">
        </selectize>

        <template v-if="$userIsGlobalAdmin && regionOptions.length > 1">
          <h3>Region</h3>
          <selectize
            class="selectize selectize-single"
            name="timezone"
            v-model="stateRegion"
            :options="regionOptions">
          </selectize>
        </template>

        <h3>Preferred Date Format</h3>
        <selectize
          class="selectize selectize-single"
          name="timezone"
          v-model="stateDateFormat"
          :options="dateFormatOptions">
        </selectize>
      </div>
      <div class="panel-footer">
        <ladda-button
          type="submit"
          class="btn btn-sm btn-primary"
          :click="handleUpdateDateTimePreferencesCallback"
          :disabled="userIsAdmin && !canEditAdmin">
          Save Changes
        </ladda-button>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Selectize from '../ext/codium/CodiumSelectize'
import { handleServerErrors, notify } from 'utils'
import { stateMapper, helpers } from 'mixins/users'
import moment from 'moment-timezone'
import { DATE_FORMAT, DATE_FORMAT_US } from '../../mixins'

export default {
  mixins: [stateMapper, helpers],
  components: {
    Selectize
  },

  data () {
    return {
      timezoneOptions: [],
      regionOptions: [],
      dateFormatOptions: [
        { id: 'day-first', text: moment().format(DATE_FORMAT) },
        { id: 'month-first', text: moment().format(DATE_FORMAT_US) }
      ]
    }
  },
  computed: mapState('user', ['user']),

  mounted () {
    this.getTimezones().then(response => {
      this.timezoneOptions = response.data.map(item => {
        return {
          id: item,
          text: item
        }
      })
    })
    this.getRegions().then(response => {
      this.regionOptions = response.data.map(item => {
        return {
          id: item.id,
          text: item.name
        }
      })
    })
  },

  methods: {
    ...mapActions('user', ['getTimezones', 'updateDateTimePreferences']),
    ...mapActions('authentication', ['setAuthorizedProperty']),
    ...mapActions('region', ['getRegions']),
    /**
     * Handle changing the users password.
     *
     * Validate the data before sending.
     *
     * @return Promise
     */
    handleUpdateDateTimePreferencesCallback () {
      let payload = {
        timezone: this.user.timezone,
        date_format_preference: this.user.date_format_preference
      }
      if (this.$userIsGlobalAdmin && this.regionOptions.length > 1) {
        payload = {...payload, regionId: this.user.region_id}
      }
      return this.updateDateTimePreferences({
        id: this.user.id,
        payload
      })
        .then(() => {
          notify.success('Successfully updated preferences.')
          if (this.user.id === this.$user.id) {
            this.setAuthorizedProperty({ property: 'date_format_preference', value: this.user.date_format_preference })
          }
        })
        .catch((error) => {
          if (error.response) {
            handleServerErrors(error, this.errors)
          } else {
            notify.error('Sorry something has gone wrong, please try again.')
            throw error
          }
        })
    }
  }
}
</script>
